module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-menu"
  }, [_c('div', {
    staticClass: "hide-overflow",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "absolute": "",
      "color": "indigo",
      "dark": "",
      "scroll-off-screen": "",
      "scroll-target": "#main-container"
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_c('h2', {
    staticStyle: {
      "flex": "1"
    }
  }, [_vm._v("Hajime Tools")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (!_vm.isLogin) ? _c('v-btn', {
    attrs: {
      "loading": _vm.authLoading,
      "small": "",
      "round": "",
      "color": "teal accent-4"
    },
    on: {
      "click": function($event) {
        _vm.showLogin = true
      }
    }
  }, [_c('v-icon', [_vm._v("assignment_ind")]), _vm._v("\n        ログイン\n      ")], 1) : (_vm.isLogin) ? _c('v-toolbar-title', [_c('h3', [_vm._v(_vm._s(((_vm.user.user) + " [" + (_vm.user.email) + "]")))])]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('v-btn', {
    attrs: {
      "small": "",
      "round": "",
      "color": "pink darken-1"
    },
    on: {
      "click": function($event) {
        _vm.showLogout = true
      }
    }
  }, [_c('v-icon', [_vm._v("directions_walk")]), _vm._v("\n        ログアウト\n      ")], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "scroll-y",
    staticStyle: {
      "max-height": "100vh",
      "padding-top": "60px !important"
    },
    attrs: {
      "id": "scrolling-techniques"
    }
  }, [_c('v-container', {
    staticStyle: {
      "height": "100vh"
    }
  }, [_vm._t("main-container", null, {
    id: "main-container"
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "side-menu"
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "mini-variant": _vm.mini,
      "absolute": "",
      "temporary": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    staticClass: "pa-1"
  }, [(_vm.mini) ? _c('v-list-tile', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("chevron_right")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-avatar', [_c('img', {
    attrs: {
      "src": require("../assets/Kirby.png")
    }
  })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Hajime-Tools")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', {
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-divider', {
    attrs: {
      "light": ""
    }
  }), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.title,
      on: {
        "click": function($event) {}
      }
    }, [(_vm.showMenueItem(item.isAuth)) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1) : _vm._e(), _vm._v(" "), (_vm.showMenueItem(item.isAuth)) ? _c('v-list-tile-content', [_c('router-link', {
      attrs: {
        "to": item.routers,
        "tag": "v-list-tile-title"
      }
    }, [_vm._v(_vm._s(item.title))])], 1) : _vm._e()], 1)
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showLogin,
      "modalColor": "blue lighten-1"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("ログイン")]), _vm._v(" "), _c('login', {
    attrs: {
      "slot": "contents",
      "auth": _vm.newAuth
    },
    on: {
      "update:auth": function($event) {
        _vm.newAuth = $event
      }
    },
    slot: "contents"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-btn', {
    attrs: {
      "color": "teal accent-4",
      "flat": ""
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("ログイン")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "pink darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showLogin = false
      }
    }
  }, [_vm._v("モドル")])], 1)], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showLogout,
      "modalColor": "pink darken-1"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("ログアウト")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "contents"
    },
    slot: "contents"
  }, [_c('h2', [_vm._v("本当にHajime-Toolからログアウトしますか?")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "action"
    },
    slot: "action"
  }, [_c('v-btn', {
    attrs: {
      "color": "teal accent-4",
      "flat": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("ログアウト")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "pink darken-1",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.showLogout = false
      }
    }
  }, [_vm._v("キャンセル")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a2ba1ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu.vue
// module id = 486
// module chunks = 1